import { Common } from './common';

import { Response } from './models/ipstack';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getIpLocation(): Promise<Response> {
    const url = this.common.constructPath('/patient-previsit/ip/location');
    return this.common.getJSON(url);
  }
}
